function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'oak': 'rgb(153, 101, 56)','black-frame': 'rgb(26, 32, 39)','chrome-frame': 'rgb(178, 188, 193)','stainless-steel-frame': 'rgb(130, 138, 145)','brass-frame': 'rgb(186, 172, 126)','copper-frame': 'rgb(242, 199, 184)','gold-frame': 'rgb(255, 207, 64)','ultrasoft-sheepskin': 'rgb(229, 223, 212)','gaucho-cowhide': 'rgb(219, 199, 177)','polo-habanero': 'rgb(80, 61, 46)','polo-tanguero': 'rgb(71, 19, 8)','polo-malbec': 'rgb(71, 19, 8)','polo-playa': 'rgb(169, 134, 112)','polo-antique': 'rgb(158, 109, 73)','polo-london': 'rgb(102, 64, 42)','polo-cactus': 'rgb(106, 114, 78)','polo-fangio': 'rgb(225, 62, 80)','vaqueta-tanguero': 'rgb(71, 19, 8)','vaqueta-cognac': 'rgb(190, 128, 87)','vaqueta-bessy': 'rgb(238, 232, 223)','vaqueta-cappuccino': 'rgb(216, 200, 187)','vaqueta-fangio': 'rgb(225, 62, 80)','vaqueta-gaucho': 'rgb(223, 212, 179)','vaqueta-habanero': 'rgb(80, 61, 46)','vaqueta-london': 'rgb(102, 64, 42)','vaqueta-moka': 'rgb(152, 104, 71)','vaqueta-playa': 'rgb(169, 134, 112)','vaqueta-sharon': 'rgb(239, 237, 238)','vaqueta-whisky': 'rgb(156, 117, 85)','vaqueta-white-cowhide': 'rgb(228, 224, 219)','vaqueta-grey-white-cowhide': 'rgb(193, 193, 193)',};

    this.images = {'oak': 'url("//www.bigbkf.com/cdn/shop/files/oakcolor_68x.jpg?v=6613173351835375687")',};

    this.triggers = ['frame color','color','colour','couleur','farbe','polo leather color','vaqueta leather color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
